(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["upsell-carousel"] && !Shopify.designMode) return;
  try {
    function formatUpsellMoney(cents, format) {
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    function withDelimiters(number, precision, thousands, decimal) {
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      const parts = number.split('.');
      const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
      const centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }
    const match = format.match(placeholderRegex);
    if (!match) return format;
    let value;
    switch (match[1]) {
      case 'amount_no_decimals':
        value = withDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        value = withDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = withDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = withDelimiters(cents, 2, ',', '.');
    }
    return format.replace(placeholderRegex, value);
  }

  class UpsellCarouselItem extends HTMLElement {
    constructor() {
      super();
      this.select = this.querySelector('.upsell-carousel__select');
      this.variantInput = this.querySelector('.upsell-carousel__variant-id');
      this.submitButton = this.querySelector('.upsell-carousel__submit');
      this.priceEl = this.querySelector('.upsell-carousel__price');
      if (this.select) {
        this.select.addEventListener('change', this.onVariantChange.bind(this));
      }
    }

    onVariantChange() {
      const option = this.select.options[this.select.selectedIndex];
      if (!option || !this.variantInput || !this.submitButton) return;

      this.variantInput.value = option.value;

      const available = option.dataset.available === 'true';
      const price = option.dataset.price || '';
      const label = this.submitButton.querySelector('span');

      this.submitButton.disabled = !available;
      if (this.priceEl) this.priceEl.textContent = price;
      if (label) {
        label.textContent = available
          ? this.submitButton.dataset.addLabel
          : this.submitButton.dataset.soldOutLabel;
      }
    }
  }

  if (!customElements.get('upsell-carousel-item')) {
    customElements.define('upsell-carousel-item', UpsellCarouselItem);
  }

  class UpsellCarouselRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.dataset.source === 'manual') {
        this.reveal();
        return;
      }

      let url = this.dataset.url;
      const productId = this.dataset.productId;
      const limit = parseInt(this.dataset.limit, 10) || 6;
      const intent = this.dataset.intent || 'related';
      const siblingPrefix = this.dataset.siblingPrefix || '';
      if (!url || !productId) return;
      if (!url.endsWith('.json')) url += '.json';

      // The recommendations API has no way to exclude colourway siblings
      // (e.g. the same bag in another colour) server-side, so when the
      // current product belongs to a swatch group we over-fetch the API's
      // max and filter siblings out client-side, then trim to the configured
      // count. Products without a swatch group skip this and fetch exactly
      // what's needed.
      const fetchLimit = siblingPrefix ? 10 : limit;

      // This theme's product page re-mounts this element via its Vue layer
      // shortly after the initial parse, which would otherwise fire this
      // fetch twice per page view (and start downloading a full set of
      // product images that are immediately discarded). Abort on disconnect
      // so the stale request never completes.
      this.abortController = new AbortController();

      fetch(`${url}?product_id=${productId}&limit=${fetchLimit}&intent=${intent}`, {
        signal: this.abortController.signal,
      })
        .then((response) => response.json())
        .then((data) => {
          let products = data.products || [];
          if (siblingPrefix) {
            products = products.filter((p) => !p.handle || !p.handle.startsWith(siblingPrefix));
          }
          this.render(products.slice(0, limit));
        })
        .catch((error) => {
          if (error.name !== 'AbortError') this.hideWrapper();
        });
    }

    disconnectedCallback() {
      if (this.abortController) this.abortController.abort();
    }

    reveal() {
      this.hidden = false;
      this.wireControls();
    }

    // This theme's PDP is Vue-powered and repeatedly (re)inserts
    // <slider-component> into the page before appending its scroll
    // container, slides, and buttons — sometimes more than once per page
    // view. That leaves Dawn's own SliderComponent permanently holding null
    // references from its constructor (it reads its children exactly once,
    // synchronously, at construction), so its prev/next click handling
    // throws instead of scrolling, no matter when we try to repair it after
    // the fact. Bypassing it and querying the live DOM at the moment of the
    // click, rather than caching anything ahead of time, is immune to
    // however many times Vue has already touched the tree by then.
    wireControls() {
      if (this.controlsWired) return;
      const prevBtn = this.querySelector('button[name="previous"]');
      const nextBtn = this.querySelector('button[name="next"]');
      if (!prevBtn || !nextBtn) return;
      this.controlsWired = true;

      const scrollByDirection = (direction) => {
        const list = this.querySelector('.upsell-carousel__slider');
        const item = list && list.querySelector('.upsell-carousel__item');
        if (!list || !item) return;
        const gap = parseFloat(getComputedStyle(list).columnGap) || 0;
        const amount = item.getBoundingClientRect().width + gap;
        list.scrollBy({ left: direction * amount, behavior: 'smooth' });
      };

      prevBtn.addEventListener('click', () => scrollByDirection(-1));
      nextBtn.addEventListener('click', () => scrollByDirection(1));
    }

    hideWrapper() {
      const wrapper = this.closest('.upsell-carousel');
      if (wrapper) wrapper.remove();
    }

    render(products) {
      if (!products.length) {
        this.hideWrapper();
        return;
      }

      const list = this.querySelector('.upsell-carousel__slider');
      list.innerHTML = '';
      const moneyFormat = this.dataset.moneyFormat;
      const lazy = this.dataset.lazy === 'true';
      const useSelector = this.dataset.useSelector === 'true';
      const addLabel = this.dataset.addLabel;
      const soldOutLabel = this.dataset.soldOutLabel;

      products.forEach((product, index) => {
        const variant = product.variants[0];
        const hasMultipleVariants = useSelector && product.variants.length > 1;
        const available = variant ? variant.available : product.available;
        const price = formatUpsellMoney(variant ? variant.price : product.price, moneyFormat);

        const li = document.createElement('li');
        li.className = 'upsell-carousel__item slider__slide';
        li.id = `Slide-${this.id || 'upsell'}-${index + 1}`;

        const imageSrc = product.featured_image
          ? product.featured_image + (product.featured_image.includes('?') ? '&' : '?') + 'width=400'
          : '';

        li.innerHTML = `
          <div class="upsell-carousel__image">
            ${
              imageSrc
                ? `<img src="${imageSrc}" alt="${product.title.replace(/"/g, '&quot;')}" ${lazy ? 'loading="lazy"' : ''}>`
                : ''
            }
          </div>
          <div class="upsell-carousel__content">
            <p class="upsell-carousel__title">${product.title}</p>
            <upsell-carousel-item>
              <p class="upsell-carousel__price">${price}</p>
              ${
                hasMultipleVariants
                  ? `<div class="upsell-carousel__select-wrapper">
                      <select class="upsell-carousel__select">
                        ${product.variants
                          .map(
                            (v) =>
                              `<option value="${v.id}" data-available="${v.available}" data-price="${formatUpsellMoney(
                                v.price,
                                moneyFormat
                              )}" ${v.id === variant.id ? 'selected' : ''}>${v.title}</option>`
                          )
                          .join('')}
                      </select>
                      <span class="upsell-carousel__select-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 100 100" height="512" viewBox="0 0 100 100" width="512"><g><path d="m67.41 45.41-2.82-2.82-14.59 14.58-14.59-14.58-2.82 2.82 17.41 17.42z"/></g></svg>
                      </span>
                    </div>`
                  : ''
              }
              <div class="upsell-carousel__form-wrapper">
                <form action="/cart/add" method="post" enctype="multipart/form-data" data-type="add-to-cart-form">
                  <input type="hidden" name="id" value="${variant.id}" class="upsell-carousel__variant-id">
                  <button type="submit" name="add" class="upsell-carousel__submit" data-add-label="${addLabel}" data-sold-out-label="${soldOutLabel}" ${
          available ? '' : 'disabled'
        }>
                    <span>${available ? addLabel : soldOutLabel}</span>
                  </button>
                </form>
              </div>
            </upsell-carousel-item>
          </div>
        `;

        list.appendChild(li);
      });

      this.reveal();
    }
  }

  if (!customElements.get('upsell-carousel-recommendations')) {
    customElements.define('upsell-carousel-recommendations', UpsellCarouselRecommendations);
  }
  } catch(e) { console.error(e); }
})();

})();
